import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why you should build a form generator",
  "description": "",
  "published": "2020-04-27T00:00:00.000Z",
  "redirect_from": ["/blog/why-you-should-build-a-form-generator/swizec/9394"],
  "categories": "Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1588001432438.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`How many forms have you built? 1? 2? 5 bazillion?`}</p>
    <p>{`Lemme guess, every project involves 1 or 2 forms and they're all the friggen same. You got forms coming out the wazoo.`}</p>
    <p>{`Render fields. Connect to state. Add field validation. Detect submit. Add form validation. Send fetch request. Repeat.`}</p>
    <p><img parentName="p" {...{
        "src": "/5092fcfc541191629a98a6ca40bf8f79/media-JtQc9M7l1KUGQ-giphy.gif",
        "alt": "shoot_me giphy"
      }}></img></p>
    <p>{`How many times can you go through that mind-numbing software bureaucracy before you say `}<strong parentName="p">{`"Enough already!"`}</strong></p>
    <p>{`And no, that doesn't mean `}<em parentName="p">{`"Give it to the most junior engineer on the team coz they still think it's exciting"`}</em>{` either. That's shitty. (and yes every company does it)`}</p>
    <h2 {...{
      "id": "build-a-form-generator"
    }}>{`Build a form generator`}</h2>
    <p>{`Here's what you do instead my friend, you notice a pattern and you solve it once and for all. For every future project. For every engineer on the team. For yourself.`}</p>
    <p>{`That's how you level up.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1251180097538678785"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.53811659192825%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'243\\'%20viewBox=\\'0%200%20400%20243\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2017c-16%208-4%2034%2013%2026%205-2%205-4%202-5-5-1-3-5%202-5%207%200%205-10-3-15-5-4-8-4-14-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/efa42ad122af5b008d01533174b12627/ca0a1/techletter.app-screenshot-1588001432438.webp 223w", "/static/efa42ad122af5b008d01533174b12627/75680/techletter.app-screenshot-1588001432438.webp 445w", "/static/efa42ad122af5b008d01533174b12627/0ba47/techletter.app-screenshot-1588001432438.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/efa42ad122af5b008d01533174b12627/e92b6/techletter.app-screenshot-1588001432438.png 223w", "/static/efa42ad122af5b008d01533174b12627/e66bf/techletter.app-screenshot-1588001432438.png 445w", "/static/efa42ad122af5b008d01533174b12627/6af66/techletter.app-screenshot-1588001432438.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/efa42ad122af5b008d01533174b12627/6af66/techletter.app-screenshot-1588001432438.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><strong parentName="p">{`Next time you're building a form, grab some extra time, turn it into a library.`}</strong></p>
    <p>{`Sure, libraries like `}<a parentName="p" {...{
        "href": "https://github.com/jaredpalmer/formik"
      }}>{`formik`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/tannerlinsley/react-form"
      }}>{`react-form`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/redux-form/redux-form"
      }}>{`redux-form`}</a>{` exist. There's a bunch for every frontend framework.`}</p>
    <p>{`And they're not what I'm talking about.`}</p>
    <p>{`What you need is a form `}<em parentName="p">{`generator`}</em>{`. A piece of code that takes JSON configuration and spits out a form.`}</p>
    <p>{`A form that looks like `}<em parentName="p">{`your`}</em>{` forms. Follows `}<em parentName="p">{`your`}</em>{` design system, has `}<em parentName="p">{`your`}</em>{` validation principles, looks like `}<em parentName="p">{`you`}</em>{` built it.`}</p>
    <h3 {...{
      "id": "form-generators-vs-forms"
    }}>{`Form generators vs. forms`}</h3>
    <p>{`Take a basic form for example. Name and email.`}</p>
    <iframe {...{
      "src": "https://codesandbox.io/embed/relaxed-moore-rl1lh?fontsize=14&hidenavigation=1&theme=dark",
      "style": {
        "width": "100%",
        "height": "500px",
        "border": "0",
        "borderRadius": "4px",
        "overflow": "hidden"
      },
      "allow": "accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking",
      "sandbox": "allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
    }}></iframe>
    <p>{`Handles 2 input fields, validates email as you type, verifies both fields are filled out before submitting.`}</p>
    <p>{`58 lines of boring code and there's a bunch of cases I didn't cover.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20Form%20%3D%20()%20%3D%3E%20%7B%0A%20%20const%20%5Bname%2C%20setName%5D%20%3D%20useState(%22%22)%3B%0A%20%20const%20%5Bemail%2C%20setEmail%5D%20%3D%20useState(%22%22)%3B%0A%20%20const%20%5BemailValidation%2C%20setEmailValidation%5D%20%3D%20useState(%22%22)%3B%0A%20%20const%20%5BformValidation%2C%20setFormValidation%5D%20%3D%20useState(%22%22)%3B%0A%0A%20%20function%20changeName(event)%20%7B%0A%20%20%20%20setName(event.target.value)%3B%0A%20%20%20%20setFormValidation(%22%22)%3B%0A%20%20%7D%0A%0A%20%20function%20changeEmail(event)%20%7B%0A%20%20%20%20const%20email%20%3D%20event.target.value%3B%0A%20%20%20%20setEmail(email)%3B%0A%0A%20%20%20%20if%20(!isValidEmail(email))%20%7B%0A%20%20%20%20%20%20setEmailValidation(%22Not%20valid%20email%22)%3B%0A%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20setEmailValidation(%22%22)%3B%0A%20%20%20%20%7D%0A%20%20%20%20setFormValidation(%22%22)%3B%0A%20%20%7D%0A%0A%20%20function%20onSubmit(event)%20%7B%0A%20%20%20%20event.preventDefault()%3B%0A%0A%20%20%20%20if%20(isValidEmail(email)%20%26%26%20name.length%20%3E%200)%20%7B%0A%20%20%20%20%20%20%2F%2F%20submit%0A%20%20%20%20%20%20setFormValidation(%22%22)%3B%0A%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20setFormValidation(%22Missing%20fields%22)%3B%0A%20%20%20%20%7D%0A%20%20%7D%0A%0A%20%20return%20(%0A%20%20%20%20%3Cform%20onSubmit%3D%7BonSubmit%7D%3E%0A%20%20%20%20%20%20%3Clabel%3E%0A%20%20%20%20%20%20%20%20Name%20%3Cinput%20type%3D%22text%22%20value%3D%7Bname%7D%20onChange%3D%7BchangeName%7D%20%2F%3E%0A%20%20%20%20%20%20%3C%2Flabel%3E%0A%20%20%20%20%20%20%3Cbr%20%2F%3E%0A%20%20%20%20%20%20%3Clabel%3E%0A%20%20%20%20%20%20%20%20Email%20%3Cinput%20type%3D%22email%22%20value%3D%7Bemail%7D%20onChange%3D%7BchangeEmail%7D%20%2F%3E%0A%20%20%20%20%20%20%3C%2Flabel%3E%0A%20%20%20%20%20%20%3Cp%3E%7BemailValidation%7D%3C%2Fp%3E%0A%20%20%20%20%20%20%3Cp%3E%7BformValidation%7D%3C%2Fp%3E%0A%20%20%20%20%20%20%3Cbutton%20type%3D%22submit%22%3ESubmit%3C%2Fbutton%3E%0A%20%20%20%20%3C%2Fform%3E%0A%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "686px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "153.36322869955157%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'613\\'%20viewBox=\\'0%200%20400%20613\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2029a29259%2029259%200%20001%20556h359l1-279V29l-181-1-180%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a429ade4c67a52324f8a00eee0d667c4/ca0a1/techletter.app-screenshot-1588001432001.webp 223w", "/static/a429ade4c67a52324f8a00eee0d667c4/75680/techletter.app-screenshot-1588001432001.webp 445w", "/static/a429ade4c67a52324f8a00eee0d667c4/7dbce/techletter.app-screenshot-1588001432001.webp 686w"],
                "sizes": "(max-width: 686px) 100vw, 686px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a429ade4c67a52324f8a00eee0d667c4/e92b6/techletter.app-screenshot-1588001432001.png 223w", "/static/a429ade4c67a52324f8a00eee0d667c4/e66bf/techletter.app-screenshot-1588001432001.png 445w", "/static/a429ade4c67a52324f8a00eee0d667c4/f6386/techletter.app-screenshot-1588001432001.png 686w"],
                "sizes": "(max-width: 686px) 100vw, 686px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a429ade4c67a52324f8a00eee0d667c4/f6386/techletter.app-screenshot-1588001432001.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Every engineer on your team goes through that `}<em parentName="p">{`every time`}</em>{` they build a form. And they build a lot.`}</p>
    <p>{`This is how they feel 👇`}</p>
    <p><img parentName="p" {...{
        "src": "/95e5098093fd2f02d3e5248b69568800/media-6y038xO1p06He-giphy.gif",
        "alt": "groan giphy"
      }}></img></p>
    <p>{`Wouldn't you?`}</p>
    <p>{`Here's what you do after `}<em parentName="p">{`someone`}</em>{` ;) builds a form generator for your team:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20fields%20%3D%20%5B%0A%09%7Bname%3A%20'name'%2C%20label%3A%20'Name'%2C%20validate%3A%20val%20%3D%3E%20val.length%20%3E%200%7D%2C%0A%09%7Bname%3A%20'email'%2C%20label%3A%20'Email'%2C%20validate%3A%20isValidEmail%7D%0A%5D%0A%0A%2F%2F%20...%0A%0A%3CForm%20fields%3D%7Bfields%7D%20onSubmit%3D%7BonSubmit%7D%20%2F%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "638px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "48.87892376681614%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'196\\'%20viewBox=\\'0%200%20400%20196\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2031c-2%202-2%20133%200%20135s356%202%20358%200%202-133%200-135-356-2-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2904c186da7534ebfa2a5cba9217ee35/ca0a1/techletter.app-screenshot-1588001432307.webp 223w", "/static/2904c186da7534ebfa2a5cba9217ee35/75680/techletter.app-screenshot-1588001432307.webp 445w", "/static/2904c186da7534ebfa2a5cba9217ee35/a2d8a/techletter.app-screenshot-1588001432307.webp 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2904c186da7534ebfa2a5cba9217ee35/e92b6/techletter.app-screenshot-1588001432307.png 223w", "/static/2904c186da7534ebfa2a5cba9217ee35/e66bf/techletter.app-screenshot-1588001432307.png 445w", "/static/2904c186da7534ebfa2a5cba9217ee35/41be6/techletter.app-screenshot-1588001432307.png 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2904c186da7534ebfa2a5cba9217ee35/41be6/techletter.app-screenshot-1588001432307.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`😍`}</p>
    <h2 {...{
      "id": "how-you-build-a-form-generator"
    }}>{`How you build a form generator`}</h2>
    <p>{`A form generator doesn't have to be complicated my friend, it just needs to get the job done.`}</p>
    <p>{`You'll need 3 parts:`}</p>
    <ol>
      <li parentName="ol">{`A generic `}<inlineCode parentName="li">{`<Field>`}</inlineCode>{` component`}</li>
      <li parentName="ol">{`A generic `}<inlineCode parentName="li">{`<Form>`}</inlineCode>{` component`}</li>
      <li parentName="ol">{`Couple of loops`}</li>
    </ol>
    <p>{`Here's a basic example that supports text fields only.`}</p>
    <iframe {...{
      "src": "https://codesandbox.io/embed/staging-frog-cmcgr?fontsize=14&hidenavigation=1&theme=dark",
      "style": {
        "width": "100%",
        "height": "500px",
        "border": "0",
        "borderRadius": "4px",
        "overflow": "hidden"
      },
      "allow": "accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking",
      "sandbox": "allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
    }}></iframe>
    <h3 {...{
      "id": ""
    }}></h3>
    <p>{`You start with a `}<inlineCode parentName="p">{`<Field>`}</inlineCode>{` component like this.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20Field%20%3D%20(%7B%20name%2C%20label%2C%20validate%20%7D)%20%3D%3E%20%7B%0A%20%20const%20%5Bvalue%2C%20setValue%5D%20%3D%20useState(%22%22)%3B%0A%20%20const%20%5Bvalidation%2C%20setValidation%5D%20%3D%20useState(%22%22)%3B%0A%0A%20%20function%20changeValue(event)%20%7B%0A%20%20%20%20const%20val%20%3D%20event.target.value%3B%0A%0A%20%20%20%20setValue(val)%3B%0A%0A%20%20%20%20if%20(validate(val))%20%7B%0A%20%20%20%20%20%20setValidation(%22%22)%3B%0A%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20setValidation(%60Invalid%20%24%7Blabel%7D%60)%3B%0A%20%20%20%20%7D%0A%20%20%7D%0A%0A%20%20return%20(%0A%20%20%20%20%3C%3E%0A%20%20%20%20%20%20%3Clabel%3E%0A%20%20%20%20%20%20%20%20%7Blabel%7D%20%3Cinput%20type%3D%22text%22%20value%3D%7Bvalue%7D%20onChange%3D%7BchangeValue%7D%20%2F%3E%0A%20%20%20%20%20%20%3C%2Flabel%3E%0A%20%20%20%20%20%20%3Cp%3E%7Bvalidation%7D%3C%2Fp%3E%0A%20%20%20%20%3C%2F%3E%0A%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "694px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "89.23766816143497%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'357\\'%20viewBox=\\'0%200%20400%20357\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2030c-2%203-1%20297%200%20299%202%202%20360%202%20362%200%201-2%202-296%200-299S21%2027%2019%2030\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/806fc333754ecfc13b0defb4087bf148/ca0a1/techletter.app-screenshot-1588001431994.webp 223w", "/static/806fc333754ecfc13b0defb4087bf148/75680/techletter.app-screenshot-1588001431994.webp 445w", "/static/806fc333754ecfc13b0defb4087bf148/181fb/techletter.app-screenshot-1588001431994.webp 694w"],
                "sizes": "(max-width: 694px) 100vw, 694px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/806fc333754ecfc13b0defb4087bf148/e92b6/techletter.app-screenshot-1588001431994.png 223w", "/static/806fc333754ecfc13b0defb4087bf148/e66bf/techletter.app-screenshot-1588001431994.png 445w", "/static/806fc333754ecfc13b0defb4087bf148/31198/techletter.app-screenshot-1588001431994.png 694w"],
                "sizes": "(max-width: 694px) 100vw, 694px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/806fc333754ecfc13b0defb4087bf148/31198/techletter.app-screenshot-1588001431994.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This component handles a complete field. Renders an input with a label, stores state, and performs validation as you type. Even renders errors.`}</p>
    <p>{`You can use render props for more flexibility. But that's often `}<em parentName="p">{`too`}</em>{` flexible. Aim to build a generator that spits out perfect forms for `}<em parentName="p">{`your`}</em>{` company. Every time.`}</p>
    <h3 {...{
      "id": "-1"
    }}></h3>
    <p>{`The `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` component is a glorified loop.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20Form%20%3D%20(%7B%20fields%20%7D)%20%3D%3E%20%7B%0A%20%20const%20%5BformValidation%2C%20setFormValidation%5D%20%3D%20useState(%22%22)%3B%0A%0A%20%20function%20onSubmit(event)%20%7B%0A%20%20%20%20event.preventDefault()%3B%0A%0A%20%20%20%20%2F%2F%20..%0A%20%20%7D%0A%0A%20%20return%20(%0A%20%20%20%20%3Cform%20onSubmit%3D%7BonSubmit%7D%3E%0A%20%20%20%20%20%20%7Bfields.map(field%20%3D%3E%20(%0A%20%20%20%20%20%20%20%20%3C%3E%0A%20%20%20%20%20%20%20%20%20%20%3CField%20%7B...field%7D%20key%3D%7Bfield.name%7D%20%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%3Cbr%20%2F%3E%0A%20%20%20%20%20%20%20%20%3C%2F%3E%0A%20%20%20%20%20%20))%7D%0A%0A%20%20%20%20%20%20%3Cp%3E%7BformValidation%7D%3C%2Fp%3E%0A%20%20%20%20%20%20%3Cbutton%20type%3D%22submit%22%3ESubmit%3C%2Fbutton%3E%0A%20%20%20%20%3C%2Fform%3E%0A%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "574px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "101.34529147982063%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'406\\'%20viewBox=\\'0%200%20400%20406\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2035c-2%201-2%2018-2%20168l1%20169c1%202%20353%202%20354%200l1-169c0-150%200-167-2-168-2-3-350-3-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cb2dc9c89c0b6dd342f27cff5a444556/ca0a1/techletter.app-screenshot-1588001432243.webp 223w", "/static/cb2dc9c89c0b6dd342f27cff5a444556/75680/techletter.app-screenshot-1588001432243.webp 445w", "/static/cb2dc9c89c0b6dd342f27cff5a444556/4e18f/techletter.app-screenshot-1588001432243.webp 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cb2dc9c89c0b6dd342f27cff5a444556/e92b6/techletter.app-screenshot-1588001432243.png 223w", "/static/cb2dc9c89c0b6dd342f27cff5a444556/e66bf/techletter.app-screenshot-1588001432243.png 445w", "/static/cb2dc9c89c0b6dd342f27cff5a444556/86389/techletter.app-screenshot-1588001432243.png 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cb2dc9c89c0b6dd342f27cff5a444556/86389/techletter.app-screenshot-1588001432243.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Loop through fields, render each one. Add a submit button, `}<inlineCode parentName="p">{`<form>`}</inlineCode>{` element, and a place to put errors.`}</p>
    <h3 {...{
      "id": "onsubmit"
    }}>{`onSubmit`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`onSubmit`}</inlineCode>{` method handles submissions. Validates all fields, runs any form-level validations, and does the thing.`}</p>
    <p>{`Something like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20function%20onSubmit(event)%20%7B%0A%20%20%20%20event.preventDefault()%3B%0A%0A%20%20%20%20const%20values%20%3D%20fields%0A%20%20%20%20%20%20.map(field%20%3D%3E%20(%7B%0A%20%20%20%20%20%20%20%20...field%2C%0A%20%20%20%20%20%20%20%20value%3A%20document.getElementsByName(field.name)%5B0%5D.value%0A%20%20%20%20%20%20%7D))%0A%20%20%20%20%20%20.filter(field%20%3D%3E%20field.validate(field.value))%0A%20%20%20%20%20%20.map(field%20%3D%3E%20(%7B%20name%3A%20field.name%2C%20value%3A%20field.value%20%7D))%3B%0A%0A%20%20%20%20if%20(values.length%20%3D%3D%3D%20fields.length)%20%7B%0A%20%20%20%20%20%20alert(JSON.stringify(values))%3B%0A%20%20%20%20%20%20setFormValidation(%22%22)%3B%0A%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20setFormValidation(%22missing%20fields%22)%3B%0A%20%20%20%20%7D%0A%20%20%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "614px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "80.26905829596413%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'321\\'%20viewBox=\\'0%200%20400%20321\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2032l-1%20129c0%20125%200%20128%202%20129h354c2-1%202-4%202-129l-1-129c-2-2-354-2-356%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6d1c166bdd0ece6667ac5ffbee4b5f44/ca0a1/techletter.app-screenshot-1588001432141.webp 223w", "/static/6d1c166bdd0ece6667ac5ffbee4b5f44/75680/techletter.app-screenshot-1588001432141.webp 445w", "/static/6d1c166bdd0ece6667ac5ffbee4b5f44/5316f/techletter.app-screenshot-1588001432141.webp 614w"],
                "sizes": "(max-width: 614px) 100vw, 614px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6d1c166bdd0ece6667ac5ffbee4b5f44/e92b6/techletter.app-screenshot-1588001432141.png 223w", "/static/6d1c166bdd0ece6667ac5ffbee4b5f44/e66bf/techletter.app-screenshot-1588001432141.png 445w", "/static/6d1c166bdd0ece6667ac5ffbee4b5f44/e9131/techletter.app-screenshot-1588001432141.png 614w"],
                "sizes": "(max-width: 614px) 100vw, 614px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/6d1c166bdd0ece6667ac5ffbee4b5f44/e9131/techletter.app-screenshot-1588001432141.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This one iterates through the fields and grabs their values straight from the DOM. A little dirty but it works ✌️`}</p>
    <p>{`You might want to find a way to communicate values from `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` components with callbacks or something. Maybe hoist state up a level or add a React context ... depends what you need.`}</p>
    <p>{`Invalid fields are thrown out and the rest collected into an array of `}<inlineCode parentName="p">{`{ name, value }`}</inlineCode>{` objects. If that array is same length as the number of fields, the form is valid.`}</p>
    <p>{`My submit alerts. Yours should call the `}<inlineCode parentName="p">{`onSubmit`}</inlineCode>{` prop function of some sort. Let the user of your form builder define what happens :)`}</p>
    <h2 {...{
      "id": "🤯"
    }}>{`🤯`}</h2>
    <p>{`An afternoon of brain-bending once, a lifetime of perfect forms.`}</p>
    <p>{`What are you waiting for? Go save your team from this pain, be the hero they need.`}</p>
    <p><img parentName="p" {...{
        "src": "/caf4b8cc66b4e9c5d94bd5d3ee65e458/media-ek4CUx2FONgHaMz9V5-giphy-downsized-medium.gif",
        "alt": "hero giphy"
      }}></img></p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      